import { Entity } from '../entity';
import { UUID } from '../uuid/entity';

export interface TechniqueProps {
    id: string;
    name?: string;
    label: string;
    description: string;
    url?: string;
    srcId?: string;
    assetTypeIds: string[];
    isCustom?: boolean;
}

export class Technique extends Entity {
    label?: string;
    description: string;
    url?: string;
    srcId?: string;
    assetTypeIds: string[];
    isCustom?: boolean;

    constructor({
        id,
        name,
        label,
        description,
        url,
        srcId,
        assetTypeIds,
        isCustom,
    }: TechniqueProps) {
        super({ id, name });
        this.id = id;
        this.name = name;
        this.label = label;
        this.description = description;
        this.url = url;
        this.srcId = srcId;
        this.assetTypeIds = assetTypeIds;
        this.isCustom = isCustom ?? false;
    }

    static new({
        name,
        label,
        description,
        url,
        srcId,
        assetTypeIds,
        isCustom,
    }: Omit<TechniqueProps, 'id'>): Technique {
        const uuid = new UUID();
        return new Technique({
            id: uuid.toString(),
            name,
            label,
            description,
            url,
            srcId,
            assetTypeIds,
            isCustom,
        });
    }
}
